export class VisitorAccount {
  constructor(public username: string) {}
}
